import request from '@/utils/request'

let PointsApi = {
    /*积分设置*/
    setPoints(data) {
        return request._post('/shop/user.points/setting', data);
    },
    /*获取设置*/
    getPoints(data) {
        return request._get('/shop/user.points/setting', data);
    },
     setPointsa(data) {
        return request._post('/shop/user.points/settinga', data);
    },
    /*获取设置*/
    getPointsa(data) {
        return request._get('/shop/user.points/settinga', data);
    },
    /*获取积分列表*/
    GetUserList(data) {
        return request._get('/shop/user.points/log', data);
    },
}
export default PointsApi;



// WEBPACK FOOTER //
// ./src/api/points.js